module.exports = __webpack_public_path__ + "static/img/tubiao_2.e43bc77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/assets/tubiao_2.jpg
// module id = PtZw
// module chunks = 1